<template>
  <router-view />
</template>

<script>
export default {
  name: 'Project'
}
</script>

<style>

</style>
